if (!customElements.get("products-carousel")) {
  class ProductsCarouselElement extends HTMLElement {
    constructor() {
      super();
      this.swiper = null; // To hold the swiper instance
      this.handleResize = this.handleResize.bind(this); // Bind the resize handler to 'this'
    }

    connectedCallback() {
      this.initSwiper(); // Initialize swiper when connected

      // Add a resize listener to check the screen width
      window.addEventListener("resize", this.handleResize);
    }

    disconnectedCallback() {
      // Cleanup the swiper instance and remove event listeners when disconnected
      this.destroySwiper();
      window.removeEventListener("resize", this.handleResize);
    }

    // Helper method to find the closest navigation buttons
    getNavigationButtons() {
      return {
        nextEl: this.parentElement.querySelector(".swiper-button-next"),
        prevEl: this.parentElement.querySelector(".swiper-button-prev"),
      };
    }

    // Initialize Swiper only if the screen width is above 1024px
    initSwiper() {
      if (window.innerWidth > 1024 && !this.swiper) {
        const configString = this.getAttribute("data-config");
        const swiperConfig = JSON.parse(configString);
        const { nextEl, prevEl } = this.getNavigationButtons();

        // Store a reference to the DOM element
        const element = this;

        // eslint-disable-next-line no-undef
        this.swiper = new Swiper(this, {
          ...swiperConfig,
          slidesPerGroupAuto: true,
          resistance: true,
          resistanceRatio: 0,
          navigation: {
            nextEl, // Closest next button
            prevEl, // Closest prev button
          },
          a11y: {
            enabled: false,
          },
          on: {
            init () {
              // Use the stored reference to the DOM element
              const hasNothingToSwipe = this.slides.length <= this.params.slidesPerView;
              if (hasNothingToSwipe) {
                element.classList.add("cards-slider--no-border-right");
              } else {
                element.classList.remove("cards-slider--no-border-right");
              }
            },
            slideChange () {
              // Recheck dynamically if content changes
              const hasNothingToSwipe = this.slides.length <= this.params.slidesPerView;
              if (hasNothingToSwipe) {
                element.classList.add("cards-slider--no-border-right");
              } else {
                element.classList.remove("cards-slider--no-border-right");
              }
            },
          },
        });
      } else {
        this.classList.toggle("swiper");
      }
    }

    // Destroy the swiper instance if it exists
    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true); // Destroy swiper instance
        this.swiper = null; // Reset the swiper reference
        this.classList.remove("swiper");
      }
    }

    // Handle the window resize to conditionally apply/remove Swiper
    handleResize() {
      if (window.innerWidth > 1024) {
        if (!this.swiper) {
          this.classList.toggle("swiper");
          this.initSwiper(); // Initialize if not already applied
        }
      } else {
        this.destroySwiper(); // Destroy swiper when width is below 1024px
      }
    }
  }

  customElements.define("products-carousel", ProductsCarouselElement);
}
